// extracted by mini-css-extract-plugin
export var circleSvg = "FooterSocialLink-module--circleSvg--01037";
export var iconWrap = "FooterSocialLink-module--iconWrap--8b23d";
export var link = "FooterSocialLink-module--link--157a7";